import { PersonalSetting } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import { updatePersonalSetting } from 'streams/currentUser/actions';
import { isViewportNarrow } from 'streams/isViewportNarrow$';

export const persistSidebarState = (newValue: 'open' | 'closed'): void => {
  if (isViewportNarrow()) return;
  dispatchAction(
    updatePersonalSetting({
      personalSetting: PersonalSetting.NAVIGATION_SIDEBAR_STATE,
      newValue,
    })
  );
};
